// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserTrialInputStartdate } from './userTrialInputStartdate';
import type { UserTrialInputDurationDays } from './userTrialInputDurationDays';
import type { UserTrialInputMessage } from './userTrialInputMessage';
import type { UserTrialInputCtaLink } from './userTrialInputCtaLink';
import type { UserTrialInputCtaLabel } from './userTrialInputCtaLabel';

/**
 * Parameters for trial user accounts
 */
export interface UserTrialInput {
  isTrial?: boolean;
  startdate?: UserTrialInputStartdate;
  durationDays?: UserTrialInputDurationDays;
  message?: UserTrialInputMessage;
  ctaLink?: UserTrialInputCtaLink;
  ctaLabel?: UserTrialInputCtaLabel;
}
